import CommonAvatar from "@/shared/components/ui/Avatar/CommonAvatar";
import CommonDropdownMenu from "@/shared/components/ui/DropDown/DropdownMenu";
import {
  formatDate,
  formatTodayOrTomorrow,
  getChannelIcon,
  isSchedulePast,
} from "@/shared/utils/helperFunctions";
import { useMainStore } from "@/stores/index";
import React from "react";

const FollowUpCard = ({ followUp, companyName, actions }) => {
  const { user } = useMainStore();
  const isPast = isSchedulePast(followUp?.scheduled_at);
  const channelLabel =
    followUp?.channel?.charAt(0).toUpperCase() + followUp?.channel?.slice(1);
  const scheduleLabel = formatTodayOrTomorrow(followUp?.scheduled_at);

  return (
    <div className="p-4 rounded-lg border border-gray-200 flex flex-col gap-2">
      <div className="flex justify-between items-center">
        <div className="flex gap-1.5 items-center">
          <h6 className="text-[0.65rem] font-normal text-gray-500 font-[Inter]">
            Reminder to {channelLabel}{" "}
          </h6>
          {getChannelIcon({
            channel: followUp?.channel === "call" ? "voice" : followUp?.channel,
            size: 14,
            iconColor: "#717680",
          })}
        </div>
        <CommonDropdownMenu
          actions={actions}
          itemId={followUp?.id}
          iconSize={12}
        />
      </div>
      <h6 className="text-[0.75rem] font-semibold text-gray-800 font-[Inter]">
        {followUp?.notes}
      </h6>
      <div className="flex gap-2 items-center">
        <div className="flex justify-between items-center gap-2">
          <p className="text-[0.65rem] font-normal text-gray-400 font-[Inter]">
            {isPast ? (
              `Completed on ${formatDate(followUp?.scheduled_at)}`
            ) : (
              <p>
                Scheduled for{" "}
                <span className="text-secondary">{scheduleLabel}</span>
              </p>
            )}
          </p>

          <div className="flex items-center">
            <CommonAvatar name={user?.name} size="sm" />
            <CommonAvatar name={companyName} size="sm" className="ml-[-4px]" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FollowUpCard;
